import { createSlice } from "@reduxjs/toolkit";

export const centerInformation = createSlice({
    name:"centerInformation",
    initialState:{
        centerInformation:JSON.parse(window.localStorage.getItem('centerInformation')) || null
    },
    reducers:{
        informationCenter: (state,action)=>{
            window.localStorage.setItem('centerInformation',JSON.stringify(action.payload));
            let centerInformation = JSON.parse(window.localStorage.getItem('centerInformation'));
            state.centerInformation = centerInformation ;
        },
        removeCenterInformation: (state) => {
            window.localStorage.removeItem('centerInformation');
            state.centerInformation=null;
            console.log('okey remove center information');
            console.log('okey logout');
        },
    }
})

export const { informationCenter,removeCenterInformation} = centerInformation.actions;

export const selectCenterInformation = state => state.centerInformation;

export default centerInformation.reducer;